module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("62RJz"))).then(() => parcelRequire('iDabs'));